const ClabeModalIcon = (): JSX.Element => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5" filter="url(#filter0_b_2_18214)">
      <path d="M63.526 34.1333H104.296V94.8148H63.526V34.1333Z" fill="#99F1BD" />
    </g>
    <path
      opacity="0.7"
      d="M63.526 94.8148L25.7556 94.8148C24.0988 94.8148 22.7556 93.4716 22.7556 91.8148L22.7556 37.1333C22.7556 35.4764 24.0988 34.1333 25.7556 34.1333L63.526 34.1333L63.526 94.8148Z"
      fill="#E0F7E9"
    />
    <rect opacity="0.4" x="55.9408" y="43.6148" width="31.2889" height="41.7185" fill="#00DC5A" />
    <rect
      opacity="0.7"
      x="63.526"
      y="85.3333"
      width="31.2889"
      height="41.7185"
      transform="rotate(-180 63.526 85.3333)"
      fill="#00DC5A"
    />
    <ellipse opacity="0.7" cx="63.526" cy="64.474" rx="13.2741" ry="13.2741" fill="#99F1BD" />
    <circle opacity="0.5" cx="63.526" cy="64.474" r="7.58519" fill="#00B94B" />
    <defs>
      <filter
        id="filter0_b_2_18214"
        x="59.526"
        y="30.1333"
        width="48.7704"
        height="68.6815"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2_18214" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2_18214"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default ClabeModalIcon;
